import React from 'react';
import PropTypes from 'prop-types';
import RadioListItem from './RadioListItem';

import styles from './RadioList.module.css';
import radioStyles from '../../RadioButton/RadioButton.module.css';
import { useAnalytics } from 'hooks/useAnalytics';

const radioListItemShape = PropTypes.shape({
  displayText: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}).isRequired;

const propTypes = {
  containingTab: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(radioListItemShape).isRequired,
  value: PropTypes.string.isRequired,
  onAccordionStateChange: PropTypes.func.isRequired,
  onItemSelect: PropTypes.func,
};

function RadioList({ containingTab, identifier, value, items, onAccordionStateChange, onItemSelect }) {
  useAnalytics(`rlp-${containingTab}-reports`, identifier, value, value);
  const radioItems = items.map((radioListItem) => {
    return (
      <RadioListItem
        key={radioListItem.value}
        containingTab={containingTab}
        identifier={identifier}
        itemDisplayText={radioListItem.displayText}
        itemValue={radioListItem.value}
        isSelected={radioListItem.value === value}
        isDisabled={radioListItem.isDisabled}
        onAccordionStateChange={onAccordionStateChange}
        onItemSelect={onItemSelect}
      />
    );
  });

  return (
    <div
      role="radiogroup"
      aria-labelledby={`${containingTab}-${identifier}`}
      className={`${styles['radio-list']} ${radioStyles.blue}`}
    >
      {radioItems}
    </div>
  );
}

RadioList.defaultProps = {
  onItemSelect: (itemValue) => {
    return (itemState) => {
      itemState.value = itemValue;
    };
  },
};

RadioList.propTypes = propTypes;

export default RadioList;
